import React from 'react'

const Facility = () => {
  return (
    <div>
      
    </div>
  )
}

export default Facility
